const REMEMBER_ME_KEY = 'paygatex_remember_me';
const REMEMBERED_EMAIL_KEY = 'paygatex_remembered_email';

export const getRememberMe = (): boolean => {
  return localStorage.getItem(REMEMBER_ME_KEY) === 'true';
};

export const setRememberMe = (value: boolean): void => {
  localStorage.setItem(REMEMBER_ME_KEY, value ? 'true' : 'false');
};

export const getRememberedEmail = (): string | null => {
  return localStorage.getItem(REMEMBERED_EMAIL_KEY);
};

export const setRememberedEmail = (email: string | null): void => {
  if (email) {
    localStorage.setItem(REMEMBERED_EMAIL_KEY, email);
    return;
  }

  localStorage.removeItem(REMEMBERED_EMAIL_KEY);
};

export const clearRememberedEmail = (): void => {
  localStorage.removeItem(REMEMBERED_EMAIL_KEY);
};
